import React from 'react';
import { Col, Row } from 'antd';
import BandWidthChart from '../BandwidthChart';

const BandwidthReportSection = ({ data, networkInData, networkOutData }) => {
  if (!data?.gatewayNetworkIn && !data?.gatewayNetworkOut) {
    return null;
  }

  return (
    <div>
      <div className="section-title">THỐNG KÊ BĂNG THÔNG GATEWAY</div>
      <Row gutter={8} style={{ marginTop: 10 }}>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">Bandwidth network in</div>
            <BandWidthChart
              height={400}
              data={networkInData}
              yLabel="Mbps"
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">Bandwidth network out</div>
            <BandWidthChart
              height={400}
              data={networkOutData}
              yLabel="Mbps"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default BandwidthReportSection;
